import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Shield } from 'lucide-react';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-slate-50 py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <Link to="/">
          <Button variant="ghost" className="mb-6">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Button>
        </Link>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Shield className="h-6 w-6 text-blue-600" />
              Privacy Policy
            </CardTitle>
          </CardHeader>
          <CardContent className="prose prose-slate max-w-none">
            <p className="text-muted-foreground">Last updated: February 2026</p>

            <h2 className="text-lg font-semibold mt-6">1. Information We Collect</h2>
            <p>
              AbbeyZone collects information necessary to provide our audit scheduling and management services, including:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Account information (name, email, phone number)</li>
              <li>Organisation details</li>
              <li>Schedule and job data</li>
              <li>Usage data and activity logs</li>
            </ul>

            <h2 className="text-lg font-semibold mt-6">2. How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Provide and improve our scheduling services</li>
              <li>Send notifications and calendar invites</li>
              <li>Maintain security and prevent fraud</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2 className="text-lg font-semibold mt-6">3. Data Security</h2>
            <p>
              We implement industry-standard security measures to protect your data, including encryption, 
              secure authentication, and regular security audits. Your data is stored securely and access 
              is restricted to authorised personnel only.
            </p>

            <h2 className="text-lg font-semibold mt-6">4. Data Retention</h2>
            <p>
              We retain your data for as long as your account is active or as needed to provide services. 
              You may request deletion of your data by contacting us directly.
            </p>

            <h2 className="text-lg font-semibold mt-6">5. Your Rights</h2>
            <p>You have the right to:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Access your personal data</li>
              <li>Request correction of inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Object to processing of your data</li>
              <li>Data portability</li>
            </ul>

            <h2 className="text-lg font-semibold mt-6">6. Contact Us</h2>
            <p>
              For privacy-related inquiries, please contact us at{' '}
              <a href="mailto:privacy@abbey5star.co.uk" className="text-blue-600 hover:underline">
                privacy@abbey5star.co.uk
              </a>
              {' '}or visit our <Link to="/contact" className="text-blue-600 hover:underline">Contact page</Link>.
            </p>

            <div className="mt-8 p-4 bg-slate-100 rounded-lg">
              <p className="text-sm text-muted-foreground">
                <strong>Abbey 5 Star Ltd</strong><br />
                Registered in England and Wales<br />
                <a href="https://www.abbey5star.co.uk" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                  www.abbey5star.co.uk
                </a>
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
